import * as React from 'react';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import {ThumbnailFileProps} from '../../../../types/mx/components';
import {PDF_MIME_TYPE} from '../../../../../common/constants/MimeTypeConstants';
import {formatBytes} from '../../../../../common/utils/GeneralUtils';

class ThumbnailFile extends React.Component<ThumbnailFileProps, {}> {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        defaultClass: '',
        showPDFBackground: false
    };

    onDelete = evt => this.props.onDelete(evt);

    render() {
        const {file, showDeleteOption, onClick, defaultClass, showPDFBackground} = this.props;
        const isPDF = file.mimeType === PDF_MIME_TYPE;
        const fileDataStyle = isPDF ? '' : 'file-data-image-info';
        const fileBoxStyle = isPDF ? 'file-box p-8' : 'file-box';
        const isUploaded = file.hasError ? 'file-box-error' : file.isUploaded ? 'file-box-uploaded' : '';
        return (
            <div className={`${defaultClass} ${fileBoxStyle} ${isUploaded} thumbnail-item`}
                 onClick={() => !!onClick ? onClick() : {}}
                 style={{backgroundImage: isPDF ? '' : `url(${file.url})`}}>
                {showPDFBackground && (isPDF || (file.url && file.url.includes('pdf'))) &&
                <div className="d-flex justify-content-center h-100">
                    <img src={AssetsManager('/assets/images/common/pdf-icon-normal.svg')}
                         className="icon" alt="pdf"/></div>}
                <div className={`justify-content-between flex-column ${
                    file.name && (file.size || file.size === 0) ? 'overlay-file-box' : 'overflow-hidden'
                    } test`}>
                    {file.isUploaded && <div className="check-icon">
                        <img src={AssetsManager('/assets/images/common/check-icon.svg')} alt="Attention"/>
                    </div>}
                    {file.name && <div className="file-weight d-flex justify-content-start flex-grow-1">
                        <p className={`file-data text-ellipsis ${fileDataStyle}`}>{file.name}</p>
                    </div>}
                    {(file.size || file.size === 0) && <div className="file-data-image-info">
                        <div className="file-weight justify-content-start flex-grow-1 d-flex">
                            <div className="file-type-icon"/>
                            <div className="file-weight-content">
                                <div className="file-data">{formatBytes(file.size)}</div>
                            </div>
                        </div>
                        {showDeleteOption &&
                        <div className="file-delete-icon d-flex" onClick={() => this.onDelete(file)}/>}
                    </div>}
                </div>
            </div>
        );
    }
}

export default ThumbnailFile;